import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { SubSidebar } from 'components/SubSidebar';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Disclosure from 'components/Disclosure';
import { Divider } from 'components/Divider';
import { Icon } from 'components/Icons/icon';
import { Props as SidebarCollapsedButtonProps } from 'components/Buttons/Button';

interface SidebarSectionProps {
  title: string;
  icon: Icon;
  children: React.ReactNode;
}

interface Props {
  children?: React.ReactNode;
  collapsedComponent?: React.ReactNode;
}

function CollapsedButton(props: SidebarCollapsedButtonProps) {
  const { children, ...restProps } = props;
  return (
    <Button {...restProps} fill minimal>
      {children}
    </Button>
  );
}

function Section(props: SidebarSectionProps) {
  const { title, icon, children } = props;
  return (
    <Disclosure fill>
      <Disclosure.Button
        alignText="left"
        iconPosition="right"
        iconRotation="bottom-to-top"
        fill
        large
        icon={icon}
        tw="rounded-none py-4 border-r-0 border-b-0 border-l-0 border-neutral-quiet"
      >
        <span tw="flex-grow">{title}</span>
      </Disclosure.Button>
      <Disclosure.Panel tw="px-4 pt-4 pb-8 space-y-6">
        {children}
      </Disclosure.Panel>
    </Disclosure>
  );
}

export function SidebarWithSections(props: Props) {
  const { children, collapsedComponent } = props;
  const { t } = useTranslation(['common']);

  return (
    <SubSidebar
      order={0}
      minSize={24}
      defaultSize={24}
      collapsedComponent={collapsedComponent}
    >
      <Button
        large
        alignText="left"
        tw="mb-2"
        minimal
        icon={ArrowLeftIcon}
        onClick={() => window.history.back()}
      >
        {t('common:buttons.back')}
      </Button>
      {children}
      <Divider />
    </SubSidebar>
  );
}

SidebarWithSections.Section = Section;
SidebarWithSections.CollapsedButton = CollapsedButton;
